import { create } from 'zustand'

export type ApiCallStatus = 'pending' | 'success' | 'error'

export interface ApiLogEntry {
  id: string
  method: string
  url: string
  startedAt: number
  durationMs?: number
  status: ApiCallStatus
  statusCode?: number
  requestBody?: unknown
  responseBody?: unknown
  error?: string
}

interface ApiDebuggerState {
  entries: ApiLogEntry[]
  addEntry: (entry: ApiLogEntry) => void
  updateEntry: (id: string, patch: Partial<ApiLogEntry>) => void
  clear: () => void
}

const MAX_ENTRIES = 20

export const useApiDebuggerStore = create<ApiDebuggerState>((set) => ({
  entries: [],
  addEntry: (entry) =>
    set((state) => {
      const nextEntries = [entry, ...state.entries].slice(0, MAX_ENTRIES)
      return { entries: nextEntries }
    }),
  updateEntry: (id, patch) =>
    set((state) => ({
      entries: state.entries.map((entry) =>
        entry.id === id ? { ...entry, ...patch } : entry
      ),
    })),
  clear: () => set({ entries: [] }),
}))
